<template>
  <div class="moneyTable"
       title="">
    <el-button size="mini" type="primary" @click="save">保存薪酬表</el-button>
    <section v-if="!simple">
      <table>
        <tr>
          <td>操作</td>
          <td v-for="(item,index) in tabledata"
              :key="item.专业职级+item.管理职级+index">
            <span class="btn"
                  @click="removeRow(index)">-</span>
          </td>
          <td>
            <span class="btn"
                  @click="addRow">+</span>
          </td>
        </tr>
        <tr>
          <td>年限</td>
          <td v-for="(item,index) in tabledata"
              :key="item.专业职级+item.管理职级+index">
            <input v-model="item.年限" />
          </td>
          <td></td>
        </tr>
        <tr>
          <td>专业职级</td>
          <td v-for="(item,index) in tabledata"
              class="selecttd"
              :key="item.专业职级+index">
            <el-select v-model="item.专业职级"
                       filterable
                       allow-create
                       placeholder=""
                       @change="_updateTableType(item,index, '专业职级')"
                       size='mini'>
              <el-option v-for="item in profission"
                         :key="item"
                         :label="item"
                         :value="item">
              </el-option>
            </el-select>
          </td>
          <td></td>
        </tr>
        <tr>
          <td>管理职级</td>
          <td v-for="(item,index) in tabledata"
              class="selecttd"
              :key="item.管理职级+index">
            <el-select v-model="item.管理职级"
                       filterable
                       size='mini'
                       placeholder=""
                       @change="_updateTableType(item,index, '管理职级')"
                       allow-create>
              <el-option v-for="item in manage"
                         :key="item"
                         :label="item"
                         :value="item">
              </el-option>
            </el-select>
          </td>
          <td></td>
        </tr>
        <tr v-for="type in ['固薪','奖金','年薪']"
            :key="type">
          <td><span>{{type}}</span><br><span>（万）</span></td>
          <td v-for="(item,index) in tabledata"
              :key="item.专业职级+item.管理职级+index">
            <input v-model="item[type]" />
          </td>
          <td></td>
        </tr>
        <tr v-for="type in ['奖金机制','奖金发放时间','递延机制','备注']"
            :key="type">
          <td><span>{{type}}</span></td>
          <td :colspan="tabledata.length+1">
            <input v-model="tablecontent[type]" />
          </td>
        </tr>
      </table>
    </section>
    <footer v-if="analyze">
      <div style="margin:8px 0">
        <span>智能薪酬录入</span>
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="_analyze">解析文本</div>
<!--
        <el-button type="primary"
                   size="mini"
                   @click="_analyze"
                   plain>解析文本</el-button> -->
      </div>
      <p class="alert">
        职级用"Enter"分开（回车分行）
        例：
        A
        SA
        VP
        D
        薪酬用 "-" 分开
        例子：AN-2-30-54,代表：AN(职级)-2（月税前固定薪酬，单位万）-30（年税前奖金）-54（税前年总薪酬）
        如果不知道，填写0.
        回车区分行。
      </p>
      <!-- <el-alert title='职级用"Enter"分开（回车分行）
例：
A
SA
VP
D
薪酬用 "-" 分开
例子：AN-2-30-54,代表：AN(职级)-2（月税前固定薪酬，单位万）-30（年税前奖金）-54（税前年总薪酬）
如果不知道，填写0.
回车区分行。'
                type="error"
                style="margin:8px 0;">
      </el-alert> -->
      <!-- <el-alert title="格式：职级-固薪-奖金-年薪；比如:AN-10-11-12;ASSO-13-14-15，解析结果为:AN：固薪10，奖金11，年薪12；ASSO：固薪13，奖金14，年薪15"
                type="error"
                style="margin-bottom:8px">
      </el-alert> -->
      <el-input type="textarea"
                :rows="10"
                placeholder='A-10-20-40
SA-15-30-60
VP-20-40-100
SVP
奖金机制：“大锅饭”式分配,2017年起，开始尝试固薪、奖金“背靠背”，依照个人情况重新制定，以标准薪酬为参考上下浮动。
奖金发放时间：项目奖，各项目完成时，发放占项目收入10%的奖金，给承揽、做、销个人；年终奖，预计将在7-8月，核算发放。
递延机制：不递延
备注：'
                v-model="analyzeStr">
      </el-input>
    </footer>
  </div>
</template>
<script>
import { moneyTable, moneyContent } from '../../statistics/variant/table.js'
import * as fixedvariant from '../../statistics/variant/fixedvariant.js'
export default {
  props: {
    companyName: { type: String, default: '' },
    department: { type: String, default: '' },
    remark: { type: Boolean, default: false },
    analyze: { type: Boolean, default: true },
  },
  data() {
    return {
      simple: false,
      analyzeStr: '',
      tableType: '',
      manage: fixedvariant.管理职级表头,
      profission: fixedvariant.专业职级表头,
      departmentOption: [],
      tabledata: JSON.parse(JSON.stringify(moneyTable)),
      tablecontent: JSON.parse(JSON.stringify(moneyContent)),
    }
  },
  watch: {
    department: function() {
      this.getData()
    },
    companyName: function() {
      this.getData()
    },
  },
  methods: {
    packup() {
      this.simple = !this.simple
    },
    analyzeMoney(str) {
      let val = str.split('-')
      if (val.length === 0) {
        return false
      }
      let obj = {
        专业职级: '',
        管理职级: '',
        固薪: val[1] ? val[1].replace(/[^0-9]/gi, '') : '',
        奖金: val[2] ? val[2].replace(/[^0-9]/gi, '') : '',
        年薪: val[3] ? val[3].replace(/[^0-9]/gi, '') : '',
      }
      let ckeckkeys = ['固薪', '奖金', '年薪']
      ckeckkeys.map(v => {
        if (obj[v] == '0') {
          obj[v] = ''
        }
      })
      let type = this.trim(val[0])
      let temptype = this.trim(val[0])
      if (!type) {
        return
      }
      let reg = /[0-9a-zA-Z]/
      for (let i = 0, len = type.length; i < len; i += 1) {
        temptype = temptype.replace(reg, '')
      }
      if (temptype === '') {
        obj.专业职级 = type
      } else {
        obj.管理职级 = type
      }
      for (let key in obj) {
        obj[key] = this.trim(obj[key])
      }
      return obj
    },
    analyzeRemark(str) {
      let keyarr = ['奖金机制', '奖金发放时间', '递延机制', '备注']
      let result = str.replace(/：/g, ':').split(':')
      let key = result[0]
      result.splice(0, 1)
      let val = result.join('')
      if (keyarr.includes(key)) {
        this.tablecontent[key] = this.tablecontent[key] + ' \n ' + val
      }
    },
    removeRow(index) {
      this.tabledata.splice(index, 1)
    },
    addRow() {
      this.tabledata.push({
        专业职级: '',
        管理职级: '',
        固薪: '',
        奖金: '',
        年薪: '',
      })
    },
    _updateTableType(item, index, type) {
      if (type === '专业职级' && item.专业职级) {
        item.管理职级 = ''
      } else if (type === '管理职级' && item.管理职级) {
        item.专业职级 = ''
      }
      this.tabledata.splice(index, 1, item)
      // console.log(this.tabledata)
    },
    _analyze() {
      let result = []
      let str = this.analyzeStr.replace(/；/g, ';').replace(/：/g, ':')
      let levelarr = str.split(/\n/g)
      levelarr.map(
        function(item) {
          if (!item) {
            return
          }
          if (
            item.includes('奖金机制') ||
            item.includes('奖金发放时间') ||
            item.includes('递延机制') ||
            item.includes('备注')
          ) {
            this.analyzeRemark(item)
          } else {
            let obj = this.analyzeMoney(item)
            if (obj) {
              result.push(obj)
            }
          }
        }.bind(this),
      )
      result.map(
        function(val) {
          let flag = true // 能否添加列
          this.tabledata.map(item => {
            let issame =
              (item.专业职级 && item.专业职级.toUpperCase() === val.专业职级.toUpperCase()) ||
              (item.管理职级 && item.管理职级 === val.管理职级)
            if (issame) {
              flag = false
              item.固薪 = val.固薪
              item.奖金 = val.奖金
              item.年薪 = val.年薪
            }
          })
          if (flag) {
            this.tabledata.push(val)
          }
        }.bind(this),
      )
      this.analyzeStr = ''
      this.$message('解析成功')
    },
    profissionQuerySearch(queryString, cb) {
      let restaurants = []
      this.profission.map(v => {
        restaurants.push({ value: v })
      })
      let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      cb(results)
    },
    manageQuerySearch(queryString, cb) {
      let restaurants = []
      this.manage.map(v => {
        restaurants.push({ value: v })
      })
      let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      cb(results)
    },
    createFilter(queryString) {
      return restaurant => {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      }
    },
    async save() {
      let data = { content: this.tablecontent, table: this.tabledata }
      let result = await window.app.service('company').updateDepartmentMoney({
        公司: this.companyName,
        部门: this.department,
        data: data,
      })
      let option = {
        type: '薪酬数据',
        account: app.user.account,
        content: {
          公司: this.companyName,
          type: 'department',
          detail: this.department,
        },
      }
      await app.service('radish').addKpi(option)
    },
    trim(str) {
      return str.replace(/(^\s*)|(\s*$)/g, '')
    },
    async getData() {
      let result = await window.app
        .service('company')
        .getDepartmentMoney({ 公司: this.companyName, 部门: this.department })
      if (result.status === 'success') {
        if (result.data) {
          this.tabledata = result.data.table
          this.tablecontent = result.data.content
        } else {
          this.tabledata = JSON.parse(JSON.stringify(moneyTable))
          this.tablecontent = JSON.parse(JSON.stringify(moneyContent))
        }
      } else {
        this.$message('获取数据出错')
      }
    },
  },
  mounted() {
    if (this.remark) {
      this.simple = true
    }
    this.getData()
  },
}
</script>
<style>
.selecttd .el-input .el-input__inner {
  padding: 0;
  border: 0;
}
.selecttd .el-icon-arrow-up:after,
.selecttd .el-icon-arrow-up:before {
  content: '';
}
</style>

<style src='../../statistics/css/moneyTable.css'  scoped></style>
